/**
 * VitalPro funnel — Step 1 subscription package cards (shared).
 * - Adds subscription line to cart via /cart/add.js
 * - Optionally redirects to strap step or moves in-page (tjMoveTo2ndMShipScreen)
 * - Refreshes cart bubble / drawer without opening the drawer
 *
 * Depends: fetch. Optional: jQuery + Slick for #GST_Pricing mobile carousel.
 */
(function (window) {
  'use strict';

  /** Only one #GST_Pricing carousel init per page (home + funnel share the same id pattern). */
  var gstPricingSliderInitLock = false;

  function getFunnelStrapUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    var normalizedRoot = String(root).replace(/\/?$/, '/');
    return normalizedRoot + 'pages/vitalpro-strap?step=strap';
  }

  function collectMembershipVariantIds() {
    var ids = [];
    document.querySelectorAll('.membership-btn[data-variant]').forEach(function (button) {
      var id = Number((button.dataset.variant || '').trim());
      if (id && ids.indexOf(id) === -1) {
        ids.push(id);
      }
    });
    return ids;
  }

  /**
   * Applies a discount code to the storefront cart so the drawer / cart page match checkout.
   * Checkout-only ?discount= URLs do not update cart.js or Liquid cart totals.
   */
  function applyDiscountToCart(code) {
    var trimmed = (code || '').trim();
    if (!trimmed) {
      return Promise.resolve();
    }
    if (window.TymewearCollabsShipping) {
      return window.TymewearCollabsShipping.applyAlongside(trimmed);
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: trimmed })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            return Promise.reject(err);
          });
        }
        return res.json();
      })
      .catch(function (err) {
        console.warn('Tymewear funnel: discount could not be applied to cart (checkout URL may still apply it):', err);
      });
  }

  /** Removes any existing membership package lines so package switches don't stack. */
  function clearMembershipPackages() {
    var packageVariantIds = collectMembershipVariantIds();
    if (!packageVariantIds.length) {
      return Promise.resolve();
    }

    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        ((cart && cart.items) || []).forEach(function (item) {
          if (packageVariantIds.indexOf(Number(item.id)) !== -1 && item.key) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) {
          return null;
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              return Promise.reject(err);
            });
          }
          return res.json();
        });
      });
  }

  function refreshCartChrome() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = (cart && cart.item_count) || 0;
        var bubbleHost = document.querySelector('#cart-icon-bubble');
        if (!bubbleHost) {
          return;
        }
        if (!bubbleHost.querySelector('.cart-count-bubble')) {
          bubbleHost.insertAdjacentHTML(
            'beforeend',
            '<div class="cart-count-bubble"><span aria-hidden="true">1</span><span class="visually-hidden">1 item</span></div>'
          );
        }
        var span = bubbleHost.querySelector('.cart-count-bubble span');
        if (span) {
          span.textContent = count;
        }
        if (window.jQuery && window.jQuery('cart-drawer').length) {
          window.jQuery('cart-drawer').load(window.location.href + ' #CartDrawer');
          window.jQuery('cart-drawer').removeClass('is-empty');
        }
      })
      .catch(function () {});
  }

  function moveToStrapInPage() {
    if (typeof window.tjMoveTo2ndMShipScreen === 'function') {
      window.tjMoveTo2ndMShipScreen();
      return;
    }
    var stepArea = document.getElementById('custYourPArea');
    if (!stepArea) {
      return;
    }
    stepArea.classList.remove('viewLeft');
    stepArea.classList.add('viewRight');
    window.setTimeout(function () {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
        return;
      }
      var $ = window.jQuery;
      if ($('.tjSlideItems').hasClass('slick-initialized')) {
        $('.tjSlideItems').slick('setPosition');
      }
      if ($('.tjSlideNavItems').hasClass('slick-initialized')) {
        $('.tjSlideNavItems').slick('setPosition');
      }
    }, 300);
  }

  /**
   * @param {string} buttonSelector - e.g. '.membership-step .membership-btn'
   * @param {{ afterAdd: 'redirect' | 'funnel' }} options
   */
  function bindPackageButtons(buttonSelector, options) {
    var opts = options || {};
    var afterAdd = opts.afterAdd === 'redirect' ? 'redirect' : 'funnel';

    document.querySelectorAll(buttonSelector).forEach(function (button) {
      if (button.getAttribute('data-tymewear-funnel-bound') === '1') {
        return;
      }
      button.setAttribute('data-tymewear-funnel-bound', '1');

      button.addEventListener('click', function () {
        var variantRaw = (button.dataset.variant || '').trim();
        var planRaw = (button.dataset.plan || '').trim();
        var discount = (button.dataset.discount || '').trim();
        var offer = (button.dataset.offer || '').trim();
        var variantId = Number(variantRaw);
        var planId = Number(planRaw);

        if (!variantId) {
          window.alert('Membership configuration error: missing variant ID for the selected package.');
          return;
        }

        var addPayload = { id: variantId, quantity: 1 };
        if (planId > 0) {
          addPayload.selling_plan = planId;
        }
        if (window.TymewearReferralGift) {
          window.TymewearReferralGift.applyToPayload(addPayload);
        }

        clearMembershipPackages()
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(addPayload)
            });
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                return Promise.reject(err);
              });
            }
            return res.json();
          })
          .then(function () {
            try {
              if (discount) {
                window.localStorage.setItem('tj_membership_discount', discount);
              } else {
                window.localStorage.removeItem('tj_membership_discount');
              }
              if (offer) {
                window.localStorage.setItem('tj_membership_offer', offer);
              } else {
                window.localStorage.removeItem('tj_membership_offer');
              }
            } catch (e) {}
            return applyDiscountToCart(discount);
          })
          .then(function () {
            refreshCartChrome();
            if (afterAdd === 'redirect') {
              window.location.href = getFunnelStrapUrl();
            } else {
              moveToStrapInPage();
            }
          })
          .catch(function (err) {
            console.error('Cart error:', err);
            var planHint =
              planId > 0 ? '' : ' Check that the selected package has a valid Selling Plan ID.';
            window.alert('Could not add this package to cart.' + planHint);
          });
      });
    });
  }

  /**
   * Mobile carousel for #GST_Pricing (matches funnel + home card rows).
   * @param {string} resizeNamespace - unique jQuery resize event namespace per section
   */
  function initPricingSlider(resizeNamespace) {
    if (gstPricingSliderInitLock) {
      return;
    }
    gstPricingSliderInitLock = true;
    var membershipResizeBound = false;
    var sliderBreakpoint = 749;

    function tryInit() {
      if (!window.jQuery || typeof window.jQuery.fn.slick !== 'function') {
        return false;
      }
      var membershipSlider = window.jQuery('#GST_Pricing');
      var sliderSettings = {
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        infinite: false,
        centerMode: true,
        centerPadding: '24px',
        initialSlide: 1,
        responsive: [{ breakpoint: sliderBreakpoint, settings: 'unslick' }]
      };

      if (!membershipSlider.length || membershipSlider.hasClass('slick-initialized')) {
        return membershipSlider.length > 0;
      }

      membershipSlider.slick(sliderSettings);
      if (!membershipResizeBound) {
        membershipResizeBound = true;
        window.jQuery(window).on('resize.' + resizeNamespace, function () {
          if (window.jQuery(window).width() > sliderBreakpoint) {
            return;
          }
          if (!membershipSlider.hasClass('slick-initialized')) {
            membershipSlider.slick(sliderSettings);
          }
        });
      }
      return true;
    }

    if (!tryInit()) {
      var slickTries = 0;
      var slickTimer = window.setInterval(function () {
        slickTries += 1;
        if (tryInit() || slickTries > 40) {
          window.clearInterval(slickTimer);
        }
      }, 50);
    }
  }

  window.TymewearFunnelMembership = {
    getFunnelStrapUrl: getFunnelStrapUrl,
    get FUNNEL_STRAP_URL() {
      return getFunnelStrapUrl();
    },
    initPricingSlider: initPricingSlider,
    bindPackageButtons: bindPackageButtons
  };
})(window);
